export default {"src":"/_next/static/media/video-tour.0cdb7ff3.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};